import React, { Fragment, useState } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import aboutimg2 from '../../images/aboutimg1.svg'
import aboutimg1 from '../../images/aboutimg2.svg'

import why1 from '../../images/why1.svg'
import why2 from '../../images/why2.svg'
import why3 from '../../images/why3.svg'
import why4 from '../../images/why4.svg'

import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import TrialFrom from '../../components/TrialForm/trialfrom';
import Journey from '../../components/journey/journey';


const AboutUsPage = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>We are the most preferred property <br/> management software <br/> for hotels, resorts, and Airbnb in 2025 </h1>
                                    <br/>
                                    <p className='mb-0'>That’s why we have our presence in 17 countries</p>
                                </div>
                            </div>
                        </div>
                </section>
                {/* <PolicySection /> */}
                <FeaturesSection />
                <section className="intro_about_section section_space pb-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={aboutimg1}/>
                                </div>
                                <div className="col-lg-6">
                                    <h2><span>Empowering Hospitality Through Simplicity</span></h2>
                                    <p>We’re on a mission to simplify hotel and resort management — so you can focus on what truly matters: delivering unforgettable guest experiences.
                                    </p>
                                    <p>Our powerful, easy-to-use software is built for hotel owners, resort managers, and vacation rental operators who are tired of juggling multiple systems, chasing spreadsheets, and losing revenue to inefficiencies. 
                                    </p>
                                    <p>Whether you run a boutique hotel or manage a chain of resorts, we give you the tools to take full control — all from one smart platform.</p>
                                </div>

                            </div>
                        </div>
                </section>

                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2><span>Built by Hospitality Experts, for Hospitality Experts</span></h2>
                                    
                                    <p>We understand the challenges of the industry because we’ve lived them. Our team brings years of experience in hotel operations, software development, and customer support. 
                                    </p>
                                    <p>Every feature we build is designed with real-world hospitality needs in mind — from seamless booking management to front desk operations, housekeeping, billing, and beyond.</p>
                                    {/* <p><b>With Little Hotelier, you will</b></p>

                                    <p className='mb-0'>Boost your bookings</p>
                                    <p className='mb-0'>Make business simple</p>
                                    <p className='mb-0'>Get help when you need it</p> */}
                                </div>

                                <div className="col-lg-6">
                                    <img src={aboutimg2}/>
                                </div>

                            </div>
                        </div>
                </section>

                <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className='col-lg-12 text-center'>
                                   <h2>Why Choose Us?</h2>
                                </div>

                                <div className='col-lg-12'>
                                   <ul className='unordered_list p-0 justify-content-center why_choose_us'>
                                    <li>
                                        <img src={why1} alt="About Us" />
                                        <div>
                                            <h3>All-in-One Simplicity:</h3>
                                            <p className='mb-0'>Replace 3–4 tools with one clean, connected system.</p>
                                        </div>
                                    </li>

                                    <li>
                                        <img src={why2} alt="About Us" />
                                        <div>
                                            <h3>Real-Time Control:</h3>
                                            <p className='mb-0'>Get a bird’s-eye view of your property — anytime, anywhere.</p>
                                        </div>
                                    </li>

                                    <li>
                                        <img src={why3} alt="About Us" />
                                        <div>
                                            <h3>Scalable & Flexible: </h3>
                                            <p className='mb-0'>Whether you manage 5 rooms or 500, we grow with you.
                                            </p>
                                        </div>
                                    </li>
                                    
                                    <li>
                                        <img src={why4} alt="About Us" />
                                        <div>
                                            <h3>Customer-Centric Support:</h3>
                                            <p className='mb-0'>We’re not just software providers — we’re partners in your success.
                                            </p>
                                        </div>
                                    </li>
                                   </ul>
                                </div>

                            </div>
                        </div>
                </section>


                <section className="what_drive section_space">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-12 what_drive_inside">
                            <h2>Our Promise</h2>
                            <p>We don’t believe in complicated tech or hidden fees. We believe in transparency, reliability, <br/> and giving you full control over your operations.
                            </p>
                            <p>We’re here to help you save time, increase revenue, and elevate the guest experience <br/> — all without the stress.
                            </p>
                        </div>
                        </div>
                    </div>
                </section>
                {/* <FaqsSection/> */}
                {/* <section className="work_thats section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3">
                                    <h2>Work that’s <br/>
                                    worthwhile.</h2>
                                </div>
                                <div className="col-lg-9">
                                    <p>Looking to make an impact in the lives of tens of thousands of hoteliers worldwide? Join a team of passionate, compassionate, and brilliant individuals for your most rewarding career move yet.
                                    </p>

                                    <Link to="/" className='learn_more'>Learn More</Link>
                                </div>
                            </div>
                        </div>
                </section> */}
                <TrialFrom />
                <Journey />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutUsPage;
